<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">
        <div class="title-wrapper mb-4">
            <div>
                <h1 class="title-default">Relatório de Entradas e Saídas por Cliente</h1>
                <p class="welcome-message">
                    <button mat-icon-button type="button" (click)="voltar()" aria-label="Voltar para relatórios de finanças">
                        <mat-icon>arrow_back</mat-icon>
                    </button>
                    Selecione os filtros abaixo para gerar o relatório detalhado de suas movimentações nas contas financeiras
                </p>
            </div>
        </div>

        @if (carregandoLookups) {
        <div class="row">
            <div class="col-12 mb-4">
                <app-loading-box [height]="'30'" [width]="'250'" [margin]="'0 0 20px 0'"></app-loading-box>

                <div class="row">
                    <div class="col-12 mb-3">
                        <app-loading-box [height]="'150'"></app-loading-box>
                    </div>
                    <div class="col-md-6 col-12 mb-3">
                        <app-loading-box [height]="'100'"></app-loading-box>
                    </div>
                    <div class="col-md-6 col-12 mb-3">
                        <app-loading-box [height]="'100'"></app-loading-box>
                    </div>
                </div>
            </div>
        </div>
        } @else {
        <section class="section-container filtros-section" [class.filtros-hidden]="!filtrosVisiveis">
            <div class="filtros-heading">
                <div class="filtros-heading-title">
                    <mat-icon>filter_alt</mat-icon>
                    <span>Filtros de pesquisa</span>
                </div>
                <div class="favoritos-toolbar">
                    <mat-form-field appearance="outline" class="favoritos-field" subscriptSizing="dynamic">
                        <mat-label>Filtros favoritos</mat-label>
                        <mat-select [formControl]="form.controls.favoritoSelecionado"
                            (selectionChange)="carregarFavoritoSelecionado()">
                            <mat-option [value]="null">Selecionar favorito</mat-option>
                            @for (favorito of favoritos; track favorito.idRelatorioFiltroFavorito) {
                            <mat-option [value]="getFavoritoValue(favorito)">{{ favorito.nome }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    @if (hasFavoritoSelecionado || hasAlgumFiltroPreenchido) {
                    <button type="button" mat-stroked-button class="btn-secondary favoritar-button" (click)="favoritarFiltros()">
                        <mat-icon>{{ hasFavoritoSelecionado ? 'delete' : 'star' }}</mat-icon>
                        {{ hasFavoritoSelecionado ? 'Remover favorito' : 'Favoritar filtros' }}
                    </button>
                    }
                </div>
            </div>

            <form [formGroup]="form" class="filtros-body">
                <div class="row g-3">
                    <div class="col-xl-4 col-lg-5 col-12 border-end-desktop">
                        <div class="d-flex flex-column gap-3 h-100">
                            <div class="field-group mb-0 campo-periodo">
                                <label class="field-caption mb-3">Período de referência</label>

                                <div class="periodo-toggle mb-0">
                                    @for (opcao of periodoOpcoes; track opcao.id) {
                                    <button type="button" class="periodo-chip"
                                        [class.periodo-chip-active]="form.get('modoPeriodo')?.value === opcao.id"
                                        (click)="selecionarModoPeriodo(opcao.id)">
                                        {{ opcao.descricao }}
                                    </button>
                                    }
                                </div>
                            </div>

                            <div class="flex-grow-1">
                                @if (isModoMes) {
                                <div class="mes-picker">
                                    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 mes-picker-field">
                                        <button matPrefix type="button" mat-icon-button class="mes-nav-btn" (click)="navegarMes(-1)"
                                            aria-label="Mês anterior">
                                            <mat-icon>chevron_left</mat-icon>
                                        </button>

                                        <input matInput class="text-center mes-input-fw" formControlName="mesAno" placeholder="MM/AAAA"
                                            (blur)="normalizarMesAno()" autocomplete="off">

                                        <button matSuffix type="button" mat-icon-button class="mes-nav-btn" (click)="navegarMes(1)"
                                            aria-label="Próximo mês">
                                            <mat-icon>chevron_right</mat-icon>
                                        </button>
                                    </mat-form-field>
                                </div>
                                } @else {
                                <div class="intervalo-grid">
                                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                                        <mat-label>Data inicial</mat-label>
                                        <input matInput [matDatepicker]="pickerInicio" formControlName="dataInicial"
                                            (input)="onDateInput($event, 'dataInicial')" placeholder="DD/MM/AAAA">
                                        <mat-datepicker-toggle matIconSuffix [for]="pickerInicio"></mat-datepicker-toggle>
                                        <mat-datepicker #pickerInicio></mat-datepicker>
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                                        <mat-label>Data final</mat-label>
                                        <input matInput [matDatepicker]="pickerFim" formControlName="dataFinal"
                                            (input)="onDateInput($event, 'dataFinal')" placeholder="DD/MM/AAAA">
                                        <mat-datepicker-toggle matIconSuffix [for]="pickerFim"></mat-datepicker-toggle>
                                        <mat-datepicker #pickerFim></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                }
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-8 col-lg-7 col-12">
                        <div class="row g-3">
                            <div class="col-12">
                                @if (carregandoClienteLookup) {
                                <app-loading-box [height]="'56'"></app-loading-box>
                                } @else {
                                <app-autocomplete-pesquisavel label="Cliente" placeholder="Qualquer cliente"
                                    [formControl]="idClienteControl" [apiUrl]="urlPessoaLookup" idField="id"
                                    nameField="descricao" displayField="descricao" [selectedItem]="clienteSelecionado"
                                    [subscriptSizing]="'dynamic'" (selectionChange)="onClienteSelecionado($event)">
                                </app-autocomplete-pesquisavel>
                                }
                            </div>

                            <div class="col-md-6 col-12">
                                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                                    <mat-label>Conta financeira</mat-label>
                                    <mat-select formControlName="idContaFinanceira">
                                        <mat-option [value]="null">Todas as contas</mat-option>
                                        @for (conta of contas; track conta.id) {
                                        <mat-option [value]="conta.id">{{ conta.descricao }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="col-md-6 col-12">
                                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                                    <mat-label>Categoria</mat-label>
                                    <mat-select formControlName="idCategoriaFinanceira">
                                        <mat-option [value]="null">Todas as categorias</mat-option>
                                        @for (categoria of categorias; track categoria.id) {
                                        <mat-option [value]="categoria.id">{{ categoria.descricao }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="filtros-footer">
                    <button type="button" mat-flat-button class="btn-primary" (click)="gerar()"
                        [disabled]="carregandoLookups || carregandoRelatorio || carregandoClienteLookup">
                        @if (!carregandoRelatorio) {
                        <mat-icon>search</mat-icon>
                        Gerar relatório
                        } @else {
                        <mat-spinner diameter="20"></mat-spinner>
                        }
                    </button>
                </div>
            </form>
        </section>

        @if (carregandoRelatorio) {
        <div class="row">
            <div class="col-12 mb-4">
                <app-loading-box [height]="'48'" [margin]="'0 0 20px 0'"></app-loading-box>
                <app-loading-box [height]="'240'"></app-loading-box>
            </div>
        </div>
        } @else if (consultaGerada && possuiResultados) {
        <section class="toolbar-card">
            <div class="toolbar-actions">
                @if (!filtrosVisiveis) {
                <button type="button" mat-flat-button class="btn-primary" (click)="toggleFiltros()">
                    <mat-icon>tune</mat-icon>
                    Exibir filtros
                </button>
                } @else {
                <button type="button" mat-stroked-button class="btn-secondary" (click)="toggleFiltros()">
                    <mat-icon>tune</mat-icon>
                    Ocultar filtros
                </button>
                }
                <button type="button" mat-stroked-button class="btn-secondary icon-only" (click)="imprimir()"
                    matTooltip="Imprimir">
                    <mat-icon>print</mat-icon>
                </button>
                <button type="button" mat-stroked-button class="btn-secondary icon-only" (click)="downloadCsv()"
                    matTooltip="Download CSV">
                    <mat-icon>download</mat-icon>
                </button>
            </div>
        </section>

        <section class="resultado-list">
            @for (grupo of grupos; track grupo.clienteId) {
            <article class="cliente-card">
                <div class="cliente-card-header">
                    <div class="cliente-info">
                        <div class="cliente-avatar">
                            <mat-icon>person</mat-icon>
                        </div>
                        <h2 class="cliente-nome">Cliente: {{ grupo.clienteNome }}</h2>
                    </div>
                </div>

                <div class="movimentacoes-table-wrapper">
                    <table class="movimentacoes-table">
                        <thead>
                            <tr>
                                <th>Data</th>
                                <th>Histórico</th>
                                <th>Categoria</th>
                                <th class="text-end">Valor</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (movimento of grupo.movimentacoes; track movimento.id) {
                            <tr>
                                <td class="td-data">{{ formatarData(movimento.data) }}</td>
                                <td>{{ movimento.historico }}</td>
                                <td><span class="categoria-badge">{{ movimento.categoria }}</span></td>
                                <td class="text-end valor-cell"
                                    [class.valor-negativo]="movimento.valor < 0"
                                    [class.valor-positivo]="movimento.valor >= 0">
                                    {{ movimento.valor | abnt:'preco' }}
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>

                <div class="resumo-stats">
                    <div class="resumo-stat">
                        <span class="resumo-stat-label">Saldo anterior</span>
                        <strong class="resumo-stat-value">{{ grupo.saldoAnterior | abnt:'preco' }}</strong>
                    </div>
                    <span class="resumo-stat-sep" aria-hidden="true">+</span>
                    <div class="resumo-stat">
                        <span class="resumo-stat-label">Total do período</span>
                        <strong class="resumo-stat-value"
                            [class.valor-negativo]="grupo.totalPeriodo < 0"
                            [class.valor-positivo]="grupo.totalPeriodo >= 0">{{ grupo.totalPeriodo | abnt:'preco' }}</strong>
                    </div>
                    <span class="resumo-stat-sep" aria-hidden="true">=</span>
                    <div class="resumo-stat resumo-stat-destaque">
                        <span class="resumo-stat-label">Saldo final</span>
                        <strong class="resumo-stat-value"
                            [class.valor-negativo]="grupo.saldoFinal < 0"
                            [class.valor-positivo]="grupo.saldoFinal >= 0">{{ grupo.saldoFinal | abnt:'preco' }}</strong>
                    </div>
                </div>
            </article>
            }

            <section class="total-geral-card">
                <div class="total-geral-row">
                    <span class="total-geral-label">Total geral do período</span>
                    <strong class="total-geral-value"
                        [class.valor-negativo]="totalGeralPeriodo < 0"
                        [class.valor-positivo]="totalGeralPeriodo >= 0">{{ totalGeralPeriodo | abnt:'preco' }}</strong>
                </div>
                <div class="total-geral-divider"></div>
                <div class="total-geral-row total-geral-final">
                    <span class="total-geral-label total-geral-label-destaque">Total geral do relatório</span>
                    <strong class="total-geral-value total-geral-value-destaque"
                        [class.valor-negativo]="totalGeralSaldoFinal < 0"
                        [class.valor-positivo]="totalGeralSaldoFinal >= 0">{{ totalGeralSaldoFinal | abnt:'preco' }}</strong>
                </div>
            </section>
        </section>
        } @else if (consultaGerada && !possuiResultados && mensagemEmptyState) {
        <section class="empty-state-card">
            <mat-icon>search_off</mat-icon>
            <p>{{ mensagemEmptyState }}</p>
        </section>
        }
        }
    </div>
</div>
